/**
 * Created by linjianxi on 2016/11/17.
 */
export const ticketTop = (state) => {
  return state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/ticket/getter.js